import { AxiosResponse } from 'axios';
import HttpError from '@/app/axios/HttpError';

export enum HTTP_STATUS_CODE {
  Ok = 200,
  ResetContent = 205,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500,
}

export function AxiosResponseTreatment(response: AxiosResponse) {
  if (response.status === HTTP_STATUS_CODE.Ok) {
    return response;
  }
  if (response.status === HTTP_STATUS_CODE.ResetContent) return response;

  if (response.status === HTTP_STATUS_CODE.BadRequest) {
    const errorCode = response.data.code ? response.data.code : '';
    if (errorCode) return Promise.reject(new HttpError(errorCode, response));
    return Promise.reject(
      new HttpError(`${response.status}. Ошибка запроса: ${response.config.baseURL}${response.config.url}`, response)
    );
  }

  if (response.status === HTTP_STATUS_CODE.NotFound && Object.prototype.hasOwnProperty.call(response.data, 'data')) {
    return response;
  }

  if (response.status === HTTP_STATUS_CODE.NotFound) {
    return Promise.reject(new HttpError(`URL: ${response.config.url} не найден`, response));
  }

  if (response.status === HTTP_STATUS_CODE.Forbidden) return Promise.reject(new HttpError('Нет доступа', response));

  if (response.status >= HTTP_STATUS_CODE.InternalServerError) {
    const errorTitle = 'Произошла техническая ошибка';
    const errorMessage = response.data.message ? response.data.message : '';
    return Promise.reject(new HttpError(`${errorTitle}: ${errorMessage}`, response));
  }

  return Promise.reject(new HttpError(response.data.message, response));
}
